const GA = {
	id: process.env.VUE_APP_GOOGLE_ANALYTICS
}

const SETTINGS = {
	
	APP_NAME: process.env.VUE_APP_APP_NAME,

	GA,

	get BACKEND_URL()
	{
		let url = process.env.VUE_APP_BACKEND_URL

		if( url.substr(-1) != '/' )
			url += '/'

		return url
	}
}

export default SETTINGS